import { render } from "./Single.vue?vue&type=template&id=15b7fbf1&scoped=true&ts=true"
import script from "./Single.vue?vue&type=script&lang=ts"
export * from "./Single.vue?vue&type=script&lang=ts"

import "./Single.vue?vue&type=style&index=0&id=15b7fbf1&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b7fbf1"]])

export default __exports__